import { configureStore } from '@reduxjs/toolkit';
import { authApi } from '../features/auth/authApi';
import { sliderApi } from '../features/slider/sliderApi';
import { sizeApi } from '../features/size/sizeApi';
import authReducer from '../features/auth/authSlice';
import { colorApi } from '../features/color/colorApi';
import { categoryApi } from '../features/category/categoryApi';
import { menuApi } from '../features/MenuApi';
import { productApi } from '../features/product/productApi';
import { contactApi } from '../features/contact/contactApi';
import { socialApi } from '../features/social/socialApi';
import { homeApi } from '../features/home/homeApi';

export const store = configureStore({
  reducer: {
    [menuApi.reducerPath]: menuApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [sliderApi.reducerPath]: sliderApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [sizeApi.reducerPath]: sizeApi.reducer,
    [colorApi.reducerPath]: colorApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [contactApi.reducerPath]: contactApi.reducer,
    [socialApi.reducerPath]: socialApi.reducer,
    [homeApi.reducerPath]: homeApi.reducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(menuApi.middleware)
      .concat(authApi.middleware)
      .concat(sliderApi.middleware)
      .concat(categoryApi.middleware)
      .concat(sizeApi.middleware)
      .concat(colorApi.middleware)
      .concat(productApi.middleware)
      .concat(contactApi.middleware)
      .concat(socialApi.middleware)
      .concat(homeApi.middleware),
});